import last from 'lodash/last';
import { noDataIdentifier } from '../../shared/constants/constants';

export function getFormattedHeaders(initialHeaders, legendFormatter) {
    return initialHeaders.reduce((result, row, rowIndex) => {
        const rowItems = [];
        row.forEach((x) => {
            const text = legendFormatter(x.dataKey, null, rowIndex);
            if (x.colspan) {
                for (let i = 0; i < x.colspan; i += 1) {
                    rowItems.push(text);
                }
            } else {
                rowItems.push(text);
            }
        });
        return [...result, rowItems];
    }, []);
}

export function getCustomizableTableCsvString(headers, data) {
    const headersString = headers.map((row) => row.join(',')).join('\n');
    const dataString = data.map((row) => row.join(',')).join('\n');

    const resultString = `${headersString}\n${dataString}`;
    const utf8SafeRegex = new RegExp(noDataIdentifier, 'g');
    return resultString.replace(utf8SafeRegex, '-');
}

export function getCustomizableTableCsvData(
    headers,
    legendFormatter,
    tableData
) {
    const formattedHeaders = getFormattedHeaders(headers, legendFormatter);

    const formattedData = tableData.map((dataRow) =>
        last(headers).map((header, index) =>
            legendFormatter(dataRow[header.dataKey], null, index)
        )
    );

    return {
        headers: formattedHeaders,
        data: formattedData,
    };
}

export function getCustomizableTableCsv(
    tableHeaders,
    legendFormatter,
    tableData
) {
    const { headers, data } = getCustomizableTableCsvData(
        tableHeaders,
        legendFormatter,
        tableData
    );

    return getCustomizableTableCsvString(headers, data);
}
